module.exports = __webpack_public_path__ + "static/media/DINERS.e8e8e00e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/DINERS.svg
// module id = 86
// module chunks = 0